import React from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RemoveUserAuth } from "../store/actions/userAction";
import jwt from "jsonwebtoken";

const AdminRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isAdmin = useSelector((state) => state.user_auth.isAdmin);
  const token = useSelector((state) => state.user_auth.token);
  const decodedToken = jwt.decode(token);
  const expiration = decodedToken.exp;
  const now = Math.floor(Date.now() / 1000);

  if (now >= expiration) {
    dispatch(RemoveUserAuth);
    history.push("/");
  }
  return (
    // Show the component only when the user is Admin
    // Otherwise, redirect the user to /home-page
    <Route
      {...rest}
      render={(props) => (isAdmin ? <Component {...props} /> : <Redirect to="/" />)}
    />
  );
};

export default AdminRoute;
